export default class HereAPI {
  constructor(domain) {
    this.HERE_API_KEY = process.env.REACT_APP_HERE_API_KEY;
    this.PLACE_INDEX = process.env.REACT_APP_PLACE_INDEX;
  }
}
